import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./family-match-enter-style.css";
import SelfGenderMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import ChildGenderMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import SelfBirthTimeMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import ChildBirthTimeMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import CalenderPicker from "../../../dialog/calender/calender-picker";
import ClockPicker from "../../../dialog/clock/clock-picker";
import BirthplacePicker from "../../../dialog/birthplace-picker/birthplace-picker";
import Loading from "../../../dialog/loading/loading";
import GoogleLoginDialog from "../../../dialog/google-login/GoogleLoginDialog";
import ConfirmDialog from "../../../dialog/confirm/confirm-dialog";
import Menulist from "../../../../constant/menulist";
import useIsMobile from "../../../../hooks/useIsMobile";
import AuthService from "../../../../service/auth-service";
import UserService from "../../../../service/user-service";
import ProductService from "../../../../service/product-service";
import SiteFooter from "../../../custom/site-footer/site-footer";
import PageSeo from "../../../custom/page-seo/page-seo";
import { trackPurchase } from "../../../../utils/meta-pixel";

//—— 從已登入用戶 profile 抽出「父母（自己）」生辰欄位當預設值 ——
//  未登入 / 未完成註冊時回空 obj，state 就用空字串預設
const getSelfPrefill = () => {
  const p = AuthService.getUserProfile();
  if (!p || p.userValidCode !== "2") return {};
  return {
    name: p.userName || "",
    gender: p.userGender || "",
    birthDate: p.userBirthDate || "",
    birthTimeSign: p.userBirthTimeSign || "",
    timeMode: p.timeMode || "0",
    birthClockTime: p.userBirthClockTime || "",
    birthLongitude:
      p.userBirthLongitude != null ? String(p.userBirthLongitude) : "",
    birthLatitude:
      p.userBirthLatitude != null ? String(p.userBirthLatitude) : "",
    birthPlace: p.userBirthPlace || "",
  };
};

const FamilyMatchEnterComponent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  //進頁時先讀 profile；若之後透過登入 dialog 才拿到 profile，會在 handleLoginSuccess 補一次
  const _prefill = getSelfPrefill();

  //父母（自己）
  const [name, setName] = useState(_prefill.name || "");
  const [gender, setGender] = useState(_prefill.gender || "");
  const [birthDate, setBirthDate] = useState(_prefill.birthDate || "");
  const [birthTime, setBirthTime] = useState(_prefill.birthTimeSign || "");
  const [selfTimeMode, setSelfTimeMode] = useState(_prefill.timeMode || "0"); //0：標準時間 / 1：真太陽時
  const [selfBirthClockTime, setSelfBirthClockTime] = useState(
    _prefill.birthClockTime || "",
  );
  const [selfLongitude, setSelfLongitude] = useState(
    _prefill.birthLongitude || "",
  );
  const [selfLatitude, setSelfLatitude] = useState(
    _prefill.birthLatitude || "",
  );

  //孩子
  const [childName, setChildName] = useState("");
  const [childGender, setChildGender] = useState("");
  const [childBirthDate, setChildBirthDate] = useState("");
  const [childBirthTime, setChildBirthTime] = useState("");
  const [childTimeMode, setChildTimeMode] = useState("0");
  const [childBirthClockTime, setChildBirthClockTime] = useState("");
  const [childLongitude, setChildLongitude] = useState("");
  const [childLatitude, setChildLatitude] = useState("");

  const [foucsIndex, setFoucsIndex] = useState(-1);

  const [showSelfGenderMenu, setShowSelfGenderMenu] = useState(false);
  const [showSelfBirthTimeMenu, setShowSelfBirthTimeMenu] = useState(false);
  const [showSelfSunTimeDes, setShowSelfSunTimeDes] = useState(false);
  const [showChildGenderMenu, setShowChildGenderMenu] = useState(false);
  const [showChildBirthTimeMenu, setShowChildBirthTimeMenu] = useState(false);
  const [showChildSunTimeDes, setShowChildSunTimeDes] = useState(false);

  //出生地選擇（一個 dialog、target 決定要填父母還是孩子）
  const [showBirthplacePicker, setShowBirthplacePicker] = useState(false);
  const [birthplaceTarget, setBirthplaceTarget] = useState("self"); //"self" 父母 / "child" 孩子
  const [selfPlaceName, setSelfPlaceName] = useState(
    _prefill.birthPlace || "",
  );
  const [childPlaceName, setChildPlaceName] = useState("");

  const openBirthplacePicker = (target) => {
    setBirthplaceTarget(target);
    setShowBirthplacePicker(true);
  };

  const handleBirthplaceSelect = ({ fullName, lat, lng }) => {
    if (birthplaceTarget === "self") {
      setSelfPlaceName(fullName || "");
      if (typeof lng === "number") setSelfLongitude(String(lng));
      if (typeof lat === "number") setSelfLatitude(String(lat));
    } else {
      setChildPlaceName(fullName || "");
      if (typeof lng === "number") setChildLongitude(String(lng));
      if (typeof lat === "number") setChildLatitude(String(lat));
    }
  };

  const isMobile = useIsMobile();
  const [navHeight, setNavHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();
  const registerFrom = location.pathname;

  //付款流程用：待產生報告的訂單編號 + 是否正在輪詢（防重複啟動）
  //  orderID 從 /checkout 導回時透過 location.state.pendingOrderID 帶過來
  const pendingOrderIdRef = useRef(location.state?.pendingOrderID || null);
  const pollingRef = useRef(false);

  useEffect(() => {
    const nav = document.querySelector(
      isMobile ? ".mobile-dashboard nav" : ".dashboard nav",
    );
    setNavHeight(nav ? nav.offsetHeight : 0);
  }, [isMobile]);

  //—— Auth gating（與其他 enter 頁同 pattern）——
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterPrompt, setShowRegisterPrompt] = useState(false);

  const formRef = useRef(null);
  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth" });

  const ensureCanInteract = () => {
    const isLogin = AuthService.getLoginStatus();
    const profile = AuthService.getUserProfile();
    if (!isLogin || !profile) {
      setShowLoginDialog(true);
      return false;
    }
    if (profile.userValidCode !== "2") {
      setShowRegisterPrompt(true);
      return false;
    }
    return true;
  };

  //表單區攔截器：未認證就阻止 click / mousedown / focus
  const gateFormEvent = (e) => {
    if (!ensureCanInteract()) {
      e.preventDefault();
      e.stopPropagation();
      if (e.target && typeof e.target.blur === "function") {
        e.target.blur();
      }
    }
  };

  const handleLoginSuccess = async ({ idToken } = {}) => {
    if (!idToken) return;
    try {
      const res = await AuthService.firebaseLogin(idToken);
      if (res.data.status) {
        AuthService.login(res.data.data);
        setShowLoginDialog(false);
        if (res.data.data.userValidCode !== "2") {
          navigate("/register", { state: { from: registerFrom } });
        } else {
          //A-1 沒回生辰欄位，需要再打 B-1 拿完整 profile 才能勾父母（自己）那側的預設值
          try {
            const infoRes = await UserService.getPersonalInfo();
            if (infoRes.data?.status) {
              AuthService.updateUserInfo(infoRes.data.data);
            }
          } catch (err) {
            console.error("[FamilyMatchEnter] 拉 personal-info 失敗:", err);
          }
          const fresh = getSelfPrefill();
          setName(fresh.name || "");
          setGender(fresh.gender || "");
          setBirthDate(fresh.birthDate || "");
          setBirthTime(fresh.birthTimeSign || "");
          setSelfTimeMode(fresh.timeMode || "0");
          setSelfBirthClockTime(fresh.birthClockTime || "");
          setSelfLongitude(fresh.birthLongitude || "");
          setSelfLatitude(fresh.birthLatitude || "");
          setSelfPlaceName(fresh.birthPlace || "");
        }
      }
    } catch (e) {
      console.error("[FamilyMatchEnter] firebase-login 失敗:", e);
    }
  };

  //判斷註冊表單的資料是否填齊備
  const isSelfReady =
    name.trim() &&
    gender &&
    birthDate &&
    (selfTimeMode === "0"
      ? birthTime
      : selfBirthClockTime && selfLongitude && selfLatitude);

  const isChildReady =
    childName.trim() &&
    childGender &&
    childBirthDate &&
    (childTimeMode === "0"
      ? childBirthTime
      : childBirthClockTime && childLongitude && childLatitude);

  const isFormComplete = Boolean(isSelfReady && isChildReady);

  const GENDER_MAP = Menulist.genderMap;
  const BIRTH_TIME_MAP = Menulist.birthTimeMap;

  //按「購買」→ 導 /checkout 選發票 → /checkout 建單、跳綠界、導回本頁
  //  用戶從綠界付款分頁切回本頁時，下面的 visibilitychange 就會開始輪詢報告
  const handlePurchase = () => {
    if (!isFormComplete) return;
    const isSelfSun = selfTimeMode === "1";
    const isChildSun = childTimeMode === "1";
    const payload = {
      //父母端
      selfName: name.trim(),
      selfGender: gender,
      selfBirth: birthDate,
      selfTimeMode,
      selfBirthTimeSign: isSelfSun ? "" : birthTime,
      selfBirthClockTime: isSelfSun ? selfBirthClockTime : "",
      selfLongitude: isSelfSun ? String(selfLongitude) : "",
      selfLatitude: isSelfSun ? String(selfLatitude) : "",
      //孩子端
      childName: childName.trim(),
      childGender,
      childBirth: childBirthDate,
      childTimeMode,
      childBirthTimeSign: isChildSun ? "" : childBirthTime,
      childBirthClockTime: isChildSun ? childBirthClockTime : "",
      childLongitude: isChildSun ? String(childLongitude) : "",
      childLatitude: isChildSun ? String(childLatitude) : "",
    };
    navigate("/checkout", {
      state: {
        planID: "digital_family",
        itemName: "親子合盤解析",
        amount: 599,
        payload,
        returnPath: location.pathname,
      },
    });
  };


  //付款分頁切回來時：輪詢「綠界 callback 是否已被後端確認（paid=true）」
  //  一確認付款（不必等 AI 跑完）就直接導 /study-room，使用者立刻看到「分析中」的書
  //  AI 跑完後書房卡片會自動切「分析中...」→「查看內容」（study-room-page 自己 poll）
  useEffect(() => {
    const startPolling = async (orderId) => {
      if (pollingRef.current) return;
      pollingRef.current = true;
      setIsLoading(true);

      //輪詢付款確認的上限：通常綠界 callback 30 秒內就會打回來，給 2 分鐘 buffer
      const MAX_TRIES = 48; //× 2.5 秒 = 2 分鐘
      const INTERVAL_MS = 2500;

      for (let i = 0; i < MAX_TRIES; i++) {
        if (pendingOrderIdRef.current !== orderId) break;
        try {
          const res = await ProductService.getFamilyMatchReportByOrder(orderId);
          const d = res.data?.data;
          //paid=true 就跳轉（不必等 ready；分析中 / 已完成 / 失敗都各自在書房有對應 UI）
          if (res.data?.status && d?.paid) {
            //Meta Pixel Purchase 事件（帶 orderID 跟後端 CAPI 去重）
            trackPurchase({
              productID: "digital_family",
              productName: "親子合盤",
              amount: 599,
              orderID: orderId,
            });
            pendingOrderIdRef.current = null;
            pollingRef.current = false;
            setIsLoading(false);
            navigate("/study-room");
            return;
          }
        } catch (e) {
          console.log(e);
        }
        await new Promise((r) => setTimeout(r, INTERVAL_MS));
      }

      //輪詢超時：付款 callback 沒收到，使用者可能根本沒付款 / 綠界異常
      pendingOrderIdRef.current = null;
      pollingRef.current = false;
      setIsLoading(false);
      navigate("/study-room");
    };

    const onVisible = () => {
      if (
        document.visibilityState === "visible" &&
        pendingOrderIdRef.current &&
        !pollingRef.current
      ) {
        startPolling(pendingOrderIdRef.current);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [navigate]);

  const handleToReport = () => {
    if (!isFormComplete) return;
    handlePurchase();
  };

  const closeAllMenus = () => {
    setShowSelfGenderMenu(false);
    setShowSelfBirthTimeMenu(false);
    setShowSelfSunTimeDes(false);
    setShowChildGenderMenu(false);
    setShowChildBirthTimeMenu(false);
    setShowChildSunTimeDes(false);
  };

  return (
    <div className="family-match-enter-page">
      <PageSeo
        title="親子合盤｜父母子女緣分"
        description="父母與子女八字合盤分析，理解孩子的命理體質，找到最適合的相處方式。看清親子關係中天生的張力與互補。"
        path="/family-enter"
      />
      {/* 產生親子合盤中（呼叫 Gemini，可能數十秒）*/}
      {isLoading && <Loading />}


      {/* 未登入訪客點到表單時跳出；關掉 → 留在當前頁 */}
      {showLoginDialog && (
        <GoogleLoginDialog
          open={showLoginDialog}
          onClose={() => {
            setShowLoginDialog(false);
          }}
          onSuccess={handleLoginSuccess}
        />
      )}

      {/* 已登入但未完成註冊；關掉 → 留在當前頁 */}
      <ConfirmDialog
        open={showRegisterPrompt}
        onClose={() => {
          setShowRegisterPrompt(false);
        }}
        onSuccess={() => {
          setShowRegisterPrompt(false);
          navigate("/register", { state: { from: registerFrom } });
        }}
        title="尚未完成註冊"
        message="填寫親子合盤資料前需完成註冊，<br>是否前往註冊頁完成？"
        confirmTxt="前往註冊"
      />

      {!isMobile && (
        <main
          className="web-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={closeAllMenus}
        >
          <img
            className="banner"
            src={`/images/bg-family-web-banner.png`}
            loading="lazy"
            alt="親子合盤"
            onClick={scrollToForm}
          />

          <div className="first-block">
            <p className="slogan">
              懂孩子，比愛孩子更重要<br></br>
              幫助你用更適合的方式陪伴孩子成長
            </p>

            <div className="feeling-question">
              <img src={`/images/ic-question-mark.png`} alt="問號"></img>
              <p className="question">你是不是也有這種時候：</p>
              <p className="feeling">不知道孩子到底在想什麼 😟</p>
              <p className="feeling">明明很愛孩子，卻總是容易吵架 😩</p>
              <p className="feeling">擔心自己是不是用錯方式教育 😟</p>
            </div>
          </div>

          <div className="second-block">
            <p>
              您將透過親子合盤解析<br></br>
              看懂孩子的天性、需求與親子互動模式
            </p>
          </div>

          <div className="third-block">
            <p className="title">愛的方式不對，再多努力也會變成壓力</p>
            <p className="sub-title">一份報告，幫助「理解＋應對」</p>
            <div className="outer">
              <div className="inner">
                <p className="inner-title">我們會告訴你</p>
                <p className="inner-answer">
                  <span className="highlight">孩子的性格本質</span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">你們之間的最佳相處模式</span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">衝突背後的真正原因</span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-family-report.png`}
              loading="lazy"
              alt="親子合盤"
            />
            <p className="slogan">
              現在就輸入彼此出生日期<br></br>立即解析孩子的內心
            </p>

            {/*資料輸入卡*/}
            <div
              className="flow-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              {/*你的姓名*/}
              <div
                className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFoucsIndex(0)}
                ></input>
              </div>

              {/*你的性別選單*/}
              <div
                className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(!showSelfGenderMenu);
                }}
              >
                <p>你的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender] || ""}
                  onFocus={() => setFoucsIndex(1)}
                ></input>
                <img src="../images/ic-brown-down.png" alt=""></img>
                {showSelfGenderMenu && (
                  <div className="float-menu">
                    <SelfGenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setGender(g)}
                      onClose={() => setShowSelfGenderMenu(false)}
                    ></SelfGenderMenu>
                  </div>
                )}
              </div>

              {/*你的出生日期*/}
              <div
                className={`item-info  ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
              >
                <p>你的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => setFoucsIndex(2)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt=""></img>
              </div>

              {/*你的標準時間／真太陽時*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="self-method"
                    id="self-standard"
                    value="standard"
                    checked={selfTimeMode === "0"}
                    onChange={() => setSelfTimeMode("0")}
                  />
                  <label htmlFor="self-standard">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="self-method"
                    id="self-sun"
                    value="sun"
                    checked={selfTimeMode === "1"}
                    onChange={() => setSelfTimeMode("1")}
                  />
                  <label htmlFor="self-sun">真太陽時</label>

                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowSelfSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  ></img>

                  <div className="suntime-tag">
                    {showSelfSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*你的出生時辰-標準時間*/}
              {selfTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    closeAllMenus();
                    setShowSelfBirthTimeMenu(!showSelfBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>你的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[birthTime] || ""}
                    readOnly
                    onFocus={() => setFoucsIndex(3)}
                  ></input>
                  <img src="../images/ic-brown-down.png" alt=""></img>
                  {showSelfBirthTimeMenu && (
                    <div className="float-menu">
                      <SelfBirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(bt) => setBirthTime(bt)}
                        onClose={() => setShowSelfBirthTimeMenu(false)}
                      ></SelfBirthTimeMenu>
                    </div>
                  )}
                </div>
              )}

              {/*你的出生時辰-真太陽時*/}
              {selfTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>你的出生時辰</p>
                    <ClockPicker
                      clockTime={selfBirthClockTime}
                      setClockTime={setSelfBirthClockTime}
                      onFocus={() => setFoucsIndex(4)}
                    />
                    <img src="../images/ic-brown-down.png" alt=""></img>
                  </div>

                  {/*快速選擇你的出生地*/}
                  <div
                    className={`item-info menu ${foucsIndex == 20 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(20);
                      openBirthplacePicker("self");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇你的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "2.5rem",
                        fontSize: "1.1rem",
                        color: selfPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {selfPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt=""></img>
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={selfLongitude}
                        onChange={(e) => setSelfLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(5)}
                      ></input>
                    </div>

                    <div className="space"></div>

                    <div
                      className={`item-info place ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={selfLatitude}
                        onChange={(e) => setSelfLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(6)}
                      ></input>
                    </div>
                  </div>
                </div>
              )}

              {/*父母 / 孩子 分隔線*/}
              <div
                style={{
                  height: "1px",
                  background: "rgba(0, 0, 0, 0.08)",
                  margin: "0.5rem 0 1.5rem 0",
                }}
              />

              {/*孩子的姓名*/}
              <div
                className={`item-info ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
              >
                <p>孩子的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={childName}
                  onChange={(e) => setChildName(e.target.value)}
                  onFocus={() => setFoucsIndex(7)}
                ></input>
              </div>

              {/*孩子的性別*/}
              <div
                className={`item-info menu ${foucsIndex == 8 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowChildGenderMenu(!showChildGenderMenu);
                }}
              >
                <p>孩子的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[childGender] || ""}
                  onFocus={() => setFoucsIndex(8)}
                ></input>
                <img src="../images/ic-brown-down.png" alt=""></img>
                {showChildGenderMenu && (
                  <div className="float-menu">
                    <ChildGenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setChildGender(g)}
                      onClose={() => setShowChildGenderMenu(false)}
                    ></ChildGenderMenu>
                  </div>
                )}
              </div>

              {/*孩子的出生日期*/}
              <div
                className={`item-info ${foucsIndex == 9 ? "foucs" : "non-focus"}`}
              >
                <p>孩子的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={childBirthDate}
                    setBirthDate={setChildBirthDate}
                    onFocus={() => setFoucsIndex(9)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt=""></img>
              </div>

              {/*孩子的標準時間／真太陽時*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="child-method"
                    id="child-standard"
                    value="standard"
                    checked={childTimeMode === "0"}
                    onChange={() => setChildTimeMode("0")}
                  />
                  <label htmlFor="child-standard">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="child-method"
                    id="child-sun"
                    value="sun"
                    checked={childTimeMode === "1"}
                    onChange={() => setChildTimeMode("1")}
                  />
                  <label htmlFor="child-sun">真太陽時</label>

                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowChildSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  ></img>

                  <div className="suntime-tag">
                    {showChildSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*孩子的出生時辰-標準時間*/}
              {childTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 10 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    closeAllMenus();
                    setShowChildBirthTimeMenu(!showChildBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>孩子的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[childBirthTime] || ""}
                    readOnly
                    onFocus={() => setFoucsIndex(10)}
                  ></input>
                  <img src="../images/ic-brown-down.png" alt=""></img>
                  {showChildBirthTimeMenu && (
                    <div className="float-menu">
                      <ChildBirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(bt) => setChildBirthTime(bt)}
                        onClose={() => setShowChildBirthTimeMenu(false)}
                      ></ChildBirthTimeMenu>
                    </div>
                  )}
                </div>
              )}

              {/*孩子的出生時辰-真太陽時*/}
              {childTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 11 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>孩子的出生時辰</p>
                    <ClockPicker
                      clockTime={childBirthClockTime}
                      setClockTime={setChildBirthClockTime}
                      onFocus={() => setFoucsIndex(11)}
                    />
                    <img src="../images/ic-brown-down.png" alt=""></img>
                  </div>

                  {/*快速選擇孩子的出生地*/}
                  <div
                    className={`item-info menu ${foucsIndex == 21 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(21);
                      openBirthplacePicker("child");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇孩子的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "2.5rem",
                        fontSize: "1.1rem",
                        color: childPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {childPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt=""></img>
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 12 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={childLongitude}
                        onChange={(e) => setChildLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(12)}
                      ></input>
                    </div>

                    <div className="space"></div>

                    <div
                      className={`item-info place ${foucsIndex == 13 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={childLatitude}
                        onChange={(e) => setChildLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(13)}
                      ></input>
                    </div>
                  </div>
                </div>
              )}

              <button
                className={`${isFormComplete ? "active" : "disabled"}`}
                disabled={!isFormComplete}
                onClick={handleToReport}
              >
                獲取親子合盤 NT$599
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              ></img>
              <span className="label">額外加贈</span>
              <span className="content">合盤諮詢１次</span>
            </div>

            <p className="expert-hint">
              對親子合盤的內容還有問題想問嗎？<br></br>
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              如果你能更早看懂孩子<br></br>
              也許你會知道，原來他不是故意叛逆
            </span>
          </div>

          <div className="six-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" alt="" />
            <p className="tell">這份親子合盤會告訴你</p>

            <div className="outline">
              <div className="item-title">
                <span className="number">1</span>
                <span>｜</span>
                <span className="title">孩子的性格本質</span>
              </div>
              <div className="item-sub">
                <span>孩子天生是什麼樣的人？</span>
                <span>壓力來時會怎麼反應？</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">2</span>
                <span>｜</span>
                <span className="title">天賦雷達圖 × 潛能職業導向</span>
              </div>
              <div className="item-sub">
                <span>看懂孩子真正擅長的方向：</span>
                <span>◆ 邏輯思維</span>
                <span>◆ 執行耐力</span>
                <span>◆ 人際協調</span>
                <span>◆ 感官藝術</span>
                <span>◆ 直覺靈感</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">3</span>
                <span>｜</span>
                <span className="title">你們的相處情況</span>
              </div>
              <div className="item-sub">
                <span>為什麼有些話一講就吵？</span>
                <span>哪些相處方式最容易失衡？</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">4</span>
                <span>｜</span>
                <span className="title">角色鏡像分析 🔥</span>
              </div>
              <div className="item-sub">
                <span>孩子眼中的你：</span>
                <span>◆ 有安全感？</span>
                <span>◆ 還是讓他不敢表達？</span>
                <span className="gap-line">父母的修練功課：</span>
                <span>◆ 可能是學習傾聽</span>
                <span>◆ 或學習真正理解孩子</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">5</span>
                <span>｜</span>
                <span className="title">衝突預警與對策 🔥</span>
              </div>
              <div className="item-sub">
                <span>提前看見容易卡住的地方：</span>
                <span>◆ 孩子越講越封閉？</span>
                <span>◆ 父母越關心，孩子越反感？</span>
                <span>◆ 提供更適合的溝通方式</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">6</span>
                <span>｜</span>
                <span className="title">給父母的功課：轉變練習</span>
              </div>
              <div className="item-sub">
                <span>一個適合你的親子練習方向</span>
                <span>可以立刻開始的小調整</span>
                <span>讓親子關係慢慢變得更靠近</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">7</span>
                <span>｜</span>
                <span className="title">結語總整理</span>
              </div>
              <div className="item-sub">
                <span>幫助你看懂：</span>
                <span>◆ 孩子的天性</span>
                <span>◆ 親子之間的課題</span>
                <span>◆ 更適合彼此的相處方式</span>
                <span className="gap-line">
                  👍 👍 親子關係，從來都是雙向成長
                </span>
              </div>
            </div>
          </div>

          <div className="seven-block">
            <p>很多親子遺憾，其實都來自太晚理解</p>
            <span onClick={scrollToForm}>現在就解鎖你們的親子合盤</span>
          </div>
          <SiteFooter />
        </main>
      )}

      {isMobile && (
        <main
          className="mobile-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={closeAllMenus}
        >
          <img
            className="banner"
            src={`/images/bg-family-mobile-banner.png`}
            loading="lazy"
            alt="親子合盤"
            onClick={scrollToForm}
          />

          <div className="first-block">
            <p className="slogan">
              懂孩子，比愛孩子更重要
              <br />
              幫助你用更適合的方式陪伴孩子成長
            </p>
            <div className="feeling-question">
              <img src={`/images/ic-question-mark.png`} alt="問號" />
              <p className="question">你是不是也有這種時候：</p>
              <p className="feeling">不知道孩子到底在想什麼 😟</p>
              <p className="feeling">明明很愛孩子，卻總是容易吵架 😩</p>
              <p className="feeling">擔心自己是不是用錯方式教育 😟</p>
            </div>
          </div>

          <div className="second-block">
            <p>
              您將透過親子合盤解析
              <br />
              看懂孩子的天性、需求與親子互動模式
            </p>
          </div>

          <div className="third-block">
            <p className="title">愛的方式不對，再多努力也會變成壓力</p>
            <p className="sub-title">一份報告，幫助「理解＋應對」</p>
            <div className="outer">
              <div className="inner">
                <p className="inner-title">我們會告訴你</p>
                <p className="inner-answer">
                  <span className="highlight">孩子的性格本質</span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">你們之間的最佳相處模式</span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">衝突背後的真正原因</span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-family-report.png`}
              loading="lazy"
              alt="親子合盤"
            />
            <p className="slogan">
              現在就輸入彼此出生日期
              <br />
              立即解析孩子的內心
            </p>

            <div
              className="flow-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              <div
                className={`item-info ${foucsIndex === 0 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFoucsIndex(0)}
                />
              </div>

              <div
                className={`item-info menu ${foucsIndex === 1 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(!showSelfGenderMenu);
                }}
              >
                <p>你的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender] || ""}
                  onFocus={() => setFoucsIndex(1)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showSelfGenderMenu && (
                  <div className="float-menu">
                    <SelfGenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setGender(g)}
                      onClose={() => setShowSelfGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex === 2 ? "foucs" : "non-focus"}`}
              >
                <p>你的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => setFoucsIndex(2)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="m-self-method"
                    id="m-self-standard"
                    value="standard"
                    checked={selfTimeMode === "0"}
                    onChange={() => setSelfTimeMode("0")}
                  />
                  <label htmlFor="m-self-standard">標準時間</label>
                </div>
                <div className="option suntime">
                  <input
                    type="radio"
                    name="m-self-method"
                    id="m-self-sun"
                    value="sun"
                    checked={selfTimeMode === "1"}
                    onChange={() => setSelfTimeMode("1")}
                  />
                  <label htmlFor="m-self-sun">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowSelfSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showSelfSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {selfTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex === 3 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    closeAllMenus();
                    setShowSelfBirthTimeMenu(!showSelfBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>你的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[birthTime] || ""}
                    readOnly
                    onFocus={() => setFoucsIndex(3)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showSelfBirthTimeMenu && (
                    <div className="float-menu">
                      <SelfBirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(bt) => setBirthTime(bt)}
                        onClose={() => setShowSelfBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {selfTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex === 4 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>你的出生時辰</p>
                    <ClockPicker
                      clockTime={selfBirthClockTime}
                      setClockTime={setSelfBirthClockTime}
                      onFocus={() => setFoucsIndex(4)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  {/*快速選擇你的出生地（mobile）*/}
                  <div
                    className={`item-info menu ${foucsIndex === 20 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(20);
                      openBirthplacePicker("self");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇你的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "1rem",
                        fontSize: "0.95rem",
                        color: selfPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {selfPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex === 5 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={selfLongitude}
                        onChange={(e) => setSelfLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(5)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex === 6 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={selfLatitude}
                        onChange={(e) => setSelfLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(6)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*父母 / 孩子 分隔線（mobile）*/}
              <div
                style={{
                  height: "1px",
                  background: "rgba(0, 0, 0, 0.08)",
                  margin: "0.5rem 0 1.5rem 0",
                }}
              />

              <div
                className={`item-info ${foucsIndex === 7 ? "foucs" : "non-focus"}`}
              >
                <p>孩子的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={childName}
                  onChange={(e) => setChildName(e.target.value)}
                  onFocus={() => setFoucsIndex(7)}
                />
              </div>

              <div
                className={`item-info menu ${foucsIndex === 8 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowChildGenderMenu(!showChildGenderMenu);
                }}
              >
                <p>孩子的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[childGender] || ""}
                  onFocus={() => setFoucsIndex(8)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showChildGenderMenu && (
                  <div className="float-menu">
                    <ChildGenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setChildGender(g)}
                      onClose={() => setShowChildGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex === 9 ? "foucs" : "non-focus"}`}
              >
                <p>孩子的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={childBirthDate}
                    setBirthDate={setChildBirthDate}
                    onFocus={() => setFoucsIndex(9)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="m-child-method"
                    id="m-child-standard"
                    value="standard"
                    checked={childTimeMode === "0"}
                    onChange={() => setChildTimeMode("0")}
                  />
                  <label htmlFor="m-child-standard">標準時間</label>
                </div>
                <div className="option suntime">
                  <input
                    type="radio"
                    name="m-child-method"
                    id="m-child-sun"
                    value="sun"
                    checked={childTimeMode === "1"}
                    onChange={() => setChildTimeMode("1")}
                  />
                  <label htmlFor="m-child-sun">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowChildSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showChildSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {childTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex === 10 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    closeAllMenus();
                    setShowChildBirthTimeMenu(!showChildBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>孩子的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[childBirthTime] || ""}
                    readOnly
                    onFocus={() => setFoucsIndex(10)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showChildBirthTimeMenu && (
                    <div className="float-menu">
                      <ChildBirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(bt) => setChildBirthTime(bt)}
                        onClose={() => setShowChildBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {childTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex === 11 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>孩子的出生時辰</p>
                    <ClockPicker
                      clockTime={childBirthClockTime}
                      setClockTime={setChildBirthClockTime}
                      onFocus={() => setFoucsIndex(11)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  {/*快速選擇孩子的出生地（mobile）*/}
                  <div
                    className={`item-info menu ${foucsIndex === 21 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(21);
                      openBirthplacePicker("child");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇孩子的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "1rem",
                        fontSize: "0.95rem",
                        color: childPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {childPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex === 12 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={childLongitude}
                        onChange={(e) => setChildLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(12)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex === 13 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={childLatitude}
                        onChange={(e) => setChildLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(13)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <button
                className={isFormComplete ? "active" : "disabled"}
                disabled={!isFormComplete}
                onClick={handleToReport}
              >
                獲取親子合盤 NT$599
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              />
              <span className="label">額外加贈</span>
            </div>

            <span className="bonus-content">合盤諮詢１次</span>

            <p className="expert-hint">
              對親子合盤的內容還有問題想問嗎？
              <br />
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              如果你能更早看懂孩子
              <br />
              也許你會知道，原來他不是故意叛逆
            </span>
          </div>

          <div className="six-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" alt="" />
            <p className="tell">這份親子合盤會告訴你</p>

            <div className="outline">
              <div className="item-title">
                <span className="number">1</span>
                <span>｜</span>
                <span className="title">孩子的性格本質</span>
              </div>
              <div className="item-sub">
                <span>孩子天生是什麼樣的人？</span>
                <span>壓力來時會怎麼反應？</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">2</span>
                <span>｜</span>
                <span className="title">天賦雷達圖 × 潛能職業導向</span>
              </div>
              <div className="item-sub">
                <span>看懂孩子真正擅長的方向：</span>
                <span>◆ 邏輯思維</span>
                <span>◆ 執行耐力</span>
                <span>◆ 人際協調</span>
                <span>◆ 感官藝術</span>
                <span>◆ 直覺靈感</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">3</span>
                <span>｜</span>
                <span className="title">你們的相處情況</span>
              </div>
              <div className="item-sub">
                <span>為什麼有些話一講就吵？</span>
                <span>哪些相處方式最容易失衡？</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">4</span>
                <span>｜</span>
                <span className="title">角色鏡像分析 🔥</span>
              </div>
              <div className="item-sub">
                <span>孩子眼中的你：</span>
                <span>◆ 有安全感？</span>
                <span>◆ 還是讓他不敢表達？</span>
                <span className="gap-line">父母的修練功課：</span>
                <span>◆ 可能是學習傾聽</span>
                <span>◆ 或學習真正理解孩子</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">5</span>
                <span>｜</span>
                <span className="title">衝突預警與對策 🔥</span>
              </div>
              <div className="item-sub">
                <span>提前看見容易卡住的地方：</span>
                <span>◆ 孩子越講越封閉？</span>
                <span>◆ 父母越關心，孩子越反感？</span>
                <span>◆ 提供更適合的溝通方式</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">6</span>
                <span>｜</span>
                <span className="title">給父母的功課：轉變練習</span>
              </div>
              <div className="item-sub">
                <span>一個適合你的親子練習方向</span>
                <span>可以立刻開始的小調整</span>
                <span>讓親子關係慢慢變得更靠近</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">7</span>
                <span>｜</span>
                <span className="title">結語總整理</span>
              </div>
              <div className="item-sub">
                <span>幫助你看懂：</span>
                <span>◆ 孩子的天性</span>
                <span>◆ 親子之間的課題</span>
                <span>◆ 更適合彼此的相處方式</span>
                <span className="gap-line">
                  👍 👍 親子關係，從來都是雙向成長
                </span>
              </div>
            </div>
          </div>

          <div className="seven-block">
            <p>很多親子遺憾，其實都來自太晚理解</p>
            <span onClick={scrollToForm}>現在就解鎖你們的親子合盤</span>
          </div>
          <SiteFooter />
        </main>
      )}

      {/* 出生地級聯選擇（真太陽時模式下用；target 決定寫給父母還是孩子） */}
      <BirthplacePicker
        open={showBirthplacePicker}
        onClose={() => setShowBirthplacePicker(false)}
        onSelect={handleBirthplaceSelect}
      />
    </div>
  );
};

export default FamilyMatchEnterComponent;
